import {MessageDescriptor} from '@lingui/core';

import {Pages} from 'shared/config/model/pages';
import {AppUrls} from 'shared/config/model/urls';

import type {ISummaryHome} from 'entities/monitor';

export type IncidentTab = 'site' | 'server' | 'port' | 'domain';

export const LAST_INCIDENTS_LIMIT = 5;

export const INCIDENT_TABS: readonly IncidentTab[] = ['site', 'server', 'port', 'domain'];

export const INCIDENT_TAB_LABELS: Record<IncidentTab, MessageDescriptor> = {
    site: Pages.MENU_SITES,
    server: Pages.MENU_SERVERS,
    port: Pages.MENU_PORTS,
    domain: Pages.MENU_DOMAINS,
};

export const INCIDENT_TAB_URLS: Record<IncidentTab, string> = {
    site: AppUrls.HTTP_INCIDENTS,
    server: AppUrls.SERVER_INCIDENTS,
    port: AppUrls.PORT_INCIDENTS,
    domain: AppUrls.DOMAIN_INCIDENTS,
};

export const getIncidentTabCount = (tab: IncidentTab, home?: ISummaryHome): number | undefined =>
    home?.[tab].unresolved_incidents;

export const isIncidentTabAvailable = (
    tab: IncidentTab,
    home?: ISummaryHome,
    hasTariffAccess = true,
): boolean =>
    home ? home[tab].create_status !== 'unavailable' : hasTariffAccess;

export const pickDefaultIncidentTab = (home?: ISummaryHome): IncidentTab =>
    INCIDENT_TABS.find(
        (tab) => (getIncidentTabCount(tab, home) ?? 0) > 0 && isIncidentTabAvailable(tab, home),
    ) ?? 'site';
